<template lang="html">
  <layout>
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-toolbar flat color="rgba(0,0,0,0)" prominent>
          <h1>My Profile</h1>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="changeCount === 0" @click="saveProfile()">Save</v-btn>
          <h3>{{remodeler.name}} {{remodeler.bbb_rating}}</h3>
        </v-toolbar>
        <v-divider />
        <v-flex md6>
          <v-card>
            <v-card-title primary-title>
              <span class="headline">Details</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                name="name"
                label="name"
                v-model="remodeler.name"
                single-line
              ></v-text-field>
              <v-text-area
                name="description"
                label="description"
                v-model="remodeler.description"
              />
              {{remodeler.email}}
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md6>
          <v-layout column wrap>
            <!-- <v-flex>
              <v-card>
                <v-card-title primary-title>
                  <span class="headline">Assets</span>
                </v-card-title>
                <v-card-text>
                  <v-img :src="remodeler.logo.url" />
                </v-card-text>
              </v-card>
            </v-flex> -->
            <v-flex>
              <v-card>
                <v-card-title primary-title>
                  <span class="headline">Locations</span>
                  <v-spacer />
                  <!-- <v-btn color="primary" @click="locationModal = true">Add Location</v-btn> -->
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="locationHeaders"
                    :items="locations"
                    hide-actions
                    class="elevation-1">
                    <template v-slot:items="props">
                      <td>{{ props.item.address }}</td>
                      <td>{{ props.item.city }}</td>
                      <td>{{ props.item.city }}</td>
                      <td>{{ props.item.zip_code}}</td>
                    </template>
                  </v-data-table>
                  <v-dialog v-model="locationModal" max-width="600px">
                    <v-card>
                      <v-toolbar color="primary">
                        <span class="headline white--text">New Location</span>
                      </v-toolbar>
                      <v-card-text>
                        <v-text-field label="Address" v-model="newLocation.address" />
                        <v-text-field label="City" v-model="newLocation.city" />
                        <v-text-field label="State" v-model="newLocation.state" />
                        <v-text-field label="Zip" v-model="newLocation.zip_code" />
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="addLocation()" color="primary" right>Submit</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex md12>
          <v-card>
            <v-card-title primary-title>
              <span class="headline">Survey</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout row wrap>
                <v-flex md6>
                  <v-checkbox
                    label="I have Installed Fiber Cement Sidings"
                    v-model="remodeler.has_already_installed_fiber_cement_sidings" :value="remodeler.has_already_installed_fiber_cement_sidings"
                    color="primary" />
                  <v-checkbox
                    label="I am a part of another Siding Rewards Program"
                    v-model="remodeler.is_already_part_of_another_siding_rewards_program"
                    :value="remodeler.is_already_part_of_another_siding_rewards_program"
                    color="primary" />
                  <v-text-field
                    name="name"
                    label="Name of Other Siding Program"
                    v-model="remodeler.other_siding_reward_program"
                    v-if="remodeler.is_already_part_of_another_siding_rewards_program"
                    single-line />
                  <v-checkbox
                    label="I subcontract my installation"
                    v-model="remodeler.does_subcontract_installation"
                    :value="remodeler.does_subcontract_installation"
                    color="primary" />
                  <v-checkbox
                    label="I have a showroom"
                    v-model="remodeler.has_showroom"
                    :value="remodeler.has_showroom"
                    color="primary" />
                  <v-checkbox
                    label="I am Bonded and Insured"
                    v-model="remodeler.is_bonded_and_insured"
                    :value="remodeler.is_bonded_and_insured"
                    color="primary" />
                  <v-checkbox
                    label="I am insured for at least 1 million dollars"
                    v-model="remodeler.is_insured_for_at_least_1_million_dollars"
                    :value="remodeler.is_insured_for_at_least_1_million_dollars"
                    color="primary" />
                </v-flex>
                <v-flex md6>
                  <v-text-field
                    name="name"
                    label="How many sales people?"
                    v-model="remodeler.number_of_sales_people"
                    single-line />
                  <v-text-field
                    name="name"
                    label="Who supplies my siding?"
                    v-model="remodeler.siding_suppliers"
                    single-line />
                  <v-select
                    :items="['Less than a year', '1-3 years', '4-7 years', 'over 7 years']"
                    box
                    label="Years in Business"
                    v-model="remodeler.years_in_business" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="confirm"
        persistent
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title primary-title>
            Are you sure?
          </v-card-title>
          <v-card-text>
            You have unsaved changes, are you sure you want to leave?
          </v-card-text>
          <v-card-actions>
            <v-btn color="red" @click="confirmLeave()">Don't Save</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveProfile()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </layout>
</template>

<script>
import Layout from '@/shared/Layout'

export default {
  data () {
    return {
      remodeler: '',
      locations: [],
      confirm: false,
      locationModal: false,
      newLocation: [],
      changeCount: 0,
      locationHeaders: [
        {
          text: 'Address'
        },
        {
          text: 'City'
        },
        {
          text: 'State'
        },
        {
          text: 'Zip'
        }
      ]
    }
  },
  components: {
    Layout
  },
  methods: {
    addLocation () {
      let location = this.newLocation
      this.$http({
        method: 'put',
        url: '/remodeler/locations',
        data: this.newLocation
      }).then((response) => {
        this.locations.push(location)
        this.locationModal = false
      })
    },
    saveProfile () {
      this.$http({
        method: 'put',
        url: '/remodeler/' + this.$auth.userId,
        data: this.remodeler
      }).then((response) => {
        this.changeCount = 0
      })
    },
    confirmLeave () {
      this.changeCount = 0
      this.$router.next()
    },
    getProfile () {
      this.$http({
        method: 'get',
        url: '/remodeler/profile'
      }).then((response) => {
        this.remodeler = response.data
      })
    },
    getLocations () {
      this.$http({
        method: 'get',
        url: '/remodeler/locations'
      }).then((response) => {
        this.locations = response.data
      })
    }
  },
  watch: {
    remodeler: {
      handler: function (newValue) {
        this.changeCount++
      },
      deep: true
    }
  },
  mounted () {
    this.getProfile()
    this.getLocations()
    this.changeCount = -1
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue